import {
  isExportJobActive,
  isExportJobTerminal,
  type ExportJob,
} from '../apiClient/fetchExportJobs';

/** Poll every 1s while exports are fresh (small jobs feel instant). */
export const POLL_FAST_MS = 1000;
/** Steady interval after the fast window (large exports). */
export const POLL_NORMAL_MS = 5000;
/** How long after watch/creation we use fast polling. */
export const POLL_FAST_WINDOW_MS = 20_000;

interface ResolveExportPollIntervalOptions {
  shouldPoll: boolean;
  watchedJobIds?: Iterable<string>;
  watchedAtByJobId?: ReadonlyMap<string, number>;
}

export function resolveExportPollIntervalMs(
  jobs: ExportJob[],
  options: ResolveExportPollIntervalOptions,
): number | false {
  if (!options.shouldPoll) {
    return false;
  }

  const now = Date.now();
  let useFast = false;

  if (options.watchedJobIds && options.watchedAtByJobId) {
    Array.from(options.watchedJobIds).forEach((jobId) => {
      const job = jobs.find((j) => j.id === jobId);
      if (job && isExportJobTerminal(job)) {
        return;
      }
      const watchedAt = options.watchedAtByJobId!.get(jobId) ?? now;
      if (now - watchedAt < POLL_FAST_WINDOW_MS) {
        useFast = true;
      }
    });
  }

  if (!useFast) {
    useFast = jobs.some((job) => {
      if (!isExportJobActive(job)) {
        return false;
      }
      const createdAt = new Date(job.created_at).getTime();
      return now - createdAt < POLL_FAST_WINDOW_MS;
    });
  }

  return useFast ? POLL_FAST_MS : POLL_NORMAL_MS;
}
